export function myPlayersReady(store) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const maxWaitTime = 10000; // 10 seconds
    const checkInterval = 300; // 0.3 seconds

    const checkLoaded = () => {
      if (store.state.myPlayersLoaded) {
        resolve();
      } else if (Date.now() - startTime > maxWaitTime) {
        reject(new Error('Timeout waiting for myPlayersLoaded to be true'));
      } else {
        setTimeout(checkLoaded, checkInterval);
      }
    };

    checkLoaded();
  });
}